import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col m12" }
const _hoisted_3 = { class: "card round white" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col",
  style: {"width":"85%"}
}
const _hoisted_7 = { class: "center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "button theme",
  style: {"width":"100%"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }),
  /*#__PURE__*/_createTextVNode("  Remove ")
], -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("div", {
              class: "col",
              style: {"width":"15%","text-align":"right"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleNotification && _ctx.toggleNotification(...args)))
            }, [
              _createElementVNode("p", null, [
                _createElementVNode("i", {
                  class: _normalizeClass(
                    'fas fa-' + _ctx.notify_icon + ' fa-fw margin-right text-theme'
                  )
                }, null, 2)
              ])
            ])
          ]),
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
            return (_openBlock(), _createElementBlock("p", { key: key }, [
              _createElementVNode("i", {
                class: _normalizeClass('fas fa-' + item.icon + ' fa-fw margin-right text-theme')
              }, null, 2),
              _createTextVNode(_toDisplayString(item.value), 1)
            ]))
          }), 128)),
          _createElementVNode("p", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteCoreID && _ctx.deleteCoreID(...args)))
          }, _hoisted_10)
        ])
      ])
    ])
  ]))
}